import { ComponentPropsWithoutRef, FC } from 'react';

export const ProfileHeightMdIcon: FC<ComponentPropsWithoutRef<'svg'>> = (props) => (
  <svg width="256" height="400" viewBox="0 0 256 400" fill="none" {...props}>
    <g clipPath="url(#clip0_3109_67918)">
      <path
        d="M121.44 324.71C149.577 324.71 172.386 302.067 172.386 274.137C172.386 246.206 149.577 223.564 121.44 223.564C93.3034 223.564 70.4941 246.206 70.4941 274.137C70.4941 302.067 93.3034 324.71 121.44 324.71Z"
        fill="black"
      />
      <path
        d="M119.076 338.872C135.495 338.872 148.806 325.658 148.806 309.359C148.806 293.06 135.495 279.846 119.076 279.846C102.656 279.846 89.3452 293.06 89.3452 309.359C89.3452 325.658 102.656 338.872 119.076 338.872Z"
        fill="black"
      />
      <path d="M93.8491 246.979H147.878L148.799 309.878H94.3423L93.8491 246.979Z" fill="black" />
      <path d="M125.56 378.126L125.451 311.015" stroke="black" strokeWidth="37.79" strokeMiterlimit="10" />
      <path d="M138.71 372.381H110.894V400H138.71H166.533L138.71 372.381Z" fill="black" />
      <path d="M110.894 393.095V400H138.71H166.533L159.577 393.095H110.894Z" fill="black" />
      <path d="M140.74 250.708H128.011V309.885H140.74V250.708Z" fill="white" />
      <path
        d="M84.645 243.349C84.645 220.59 95.9816 220.273 118.909 220.273C141.836 220.273 160.426 220.59 160.426 243.349C160.426 266.109 146.782 284.562 133.415 284.562C110.488 284.562 84.645 266.109 84.645 243.349Z"
        fill="white"
      />
      <path d="M111.054 378.126L110.945 311.015" stroke="black" strokeWidth="37.79" strokeMiterlimit="10" />
      <path d="M124.203 372.381H96.3877V400H124.203H152.026L124.203 372.381Z" fill="#1B1F2C" />
      <path d="M96.3877 393.095V400H124.203H152.026L145.071 393.095H96.3877Z" fill="black" />
      <path d="M122.956 242.666V198.969" stroke="#FFB300" strokeWidth="50.38" strokeMiterlimit="10" />
      <path d="M135.286 283.893L104.686 242.089H141.227L135.286 283.893Z" fill="#FFB300" />
      <path
        d="M144.614 141.894C152.93 141.894 159.671 135.202 159.671 126.947C159.671 118.692 152.93 112 144.614 112C136.298 112 129.556 118.692 129.556 126.947C129.556 135.202 136.298 141.894 144.614 141.894Z"
        fill="#FF8F00"
      />
      <path
        d="M124.907 214.283C151.882 214.283 173.749 192.576 173.749 165.798C173.749 139.021 151.882 117.313 124.907 117.313C97.932 117.313 76.0645 139.021 76.0645 165.798C76.0645 192.576 97.932 214.283 124.907 214.283Z"
        fill="#FFB600"
      />
      <path
        d="M125.117 221.267L101.603 203.13L101.566 126.947L161.506 165.136L161.629 183.957C161.76 204.081 145.397 221.267 125.125 221.267H125.117Z"
        fill="#FFB600"
      />
      <path
        d="M180.814 165.136C180.814 195.787 155.784 220.634 124.907 220.634C94.0305 220.634 69 195.787 69 165.136"
        fill="#FFB600"
      />
      <path
        d="M157.952 165.136C173.43 165.136 186 177.614 186 192.979C186 208.343 173.43 220.821 157.952 220.821H148.037C138.028 220.821 129.904 212.757 129.904 202.821V192.979C129.904 177.614 142.474 165.136 157.952 165.136Z"
        fill="white"
      />
      <path
        d="M116.363 154.667C116.363 151.089 119.286 148.187 122.891 148.187C126.495 148.187 129.418 151.089 129.418 154.667M163.276 154.667C163.276 151.089 160.353 148.187 156.748 148.187C153.143 148.187 150.22 151.089 150.22 154.667"
        fill="#1B1F2C"
      />
      <path
        d="M164.48 165.136C164.48 168.715 161.557 171.616 157.952 171.616C154.347 171.616 151.424 168.715 151.424 165.136"
        fill="#1B1F2C"
      />
      <path
        d="M89.4901 141.894C97.8061 141.894 104.548 135.202 104.548 126.947C104.548 118.692 97.8061 112 89.4901 112C81.1741 112 74.4326 118.692 74.4326 126.947C74.4326 135.202 81.1741 141.894 89.4901 141.894Z"
        fill="#FF8F00"
      />
    </g>
    <defs>
      <clipPath id="clip0_3109_67918">
        <rect width="117" height="288" fill="white" transform="translate(69 112)" />
      </clipPath>
    </defs>
  </svg>
);
